export const CALENDAR_DATA_CHANGED_EVENT = 'eaxfuel:calendar-data-changed';

export function announceCalendarDataChanged(detail = {}) {
  if (typeof globalThis.dispatchEvent !== 'function' || typeof globalThis.CustomEvent !== 'function') return;
  globalThis.dispatchEvent(new globalThis.CustomEvent(CALENDAR_DATA_CHANGED_EVENT, { detail }));
}
